import axiosInstance from '../api/axios';


// Function to get all students
export const getAllFeedbacks = async () => {
    try {
        var id=-1;
        const response = await axiosInstance.get(`/thesisFeedbacks?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};

export const getAllExaminerFeedbacks = async (id) => {
    try {
        const response = await axiosInstance.get(`/thesisExaminerFeedbacks?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};


export const getAllStudentFeedbacks = async (id,isView) => {
    try {
  
        const response = await axiosInstance.get(`/thesisFeedbacks?id=${id}&isView=${isView}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};

export const getAllThesisGrades = async () => {
    try {
        const response = await axiosInstance.get(`/thesisGrades`);
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};

export const getSharedStudentFeedback = async (id,isView) => {
    try {
  
        const response = await axiosInstance.get(`/shareToStudent?id=${id}&isView=${isView}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching feedback:', error);
        throw error;
    }
};